<p-stepper [value]="activeStep()" [linear]="true">
  <p-step-list>
    <p-step [value]="1">{{ 'selectOrganisationType' | translate }}</p-step>
    <p-step [value]="2">{{ 'selectOrganisation' | translate }}</p-step>
    <p-step [value]="3">{{ 'selectRole' | translate }}</p-step>
  </p-step-list>
  <p-step-panels>
    <p-step-panel [value]="1">
      <ng-template #content>
        <p-listbox
          id="shadowOrgTypeListbox"
          [options]="orgTypes()"
          optionValue="value"
          [ngModel]="selectedOrgType()"
          (ngModelChange)="onOrgTypeChange($event)"
          [disabled]="loadingOrgTypes()"
          [scrollHeight]="listboxScrollHeight"
          class="w-full"
          [ariaLabel]="'selectOrganisationType' | translate"
        >
          <ng-template #item let-orgType>
            {{ orgTypeTranslationKey(orgType.value ?? '') | translate }}
          </ng-template>
        </p-listbox>
      </ng-template>
    </p-step-panel>

    <p-step-panel [value]="2">
      <ng-template #content>
        <p-listbox
          id="shadowOrganisationListbox"
          [options]="organisations()"
          optionValue="id"
          dataKey="id"
          [ngModel]="selectedOrganisationId()"
          (ngModelChange)="onOrganisationChange($event)"
          [disabled]="loadingOrganisations()"
          [filter]="true"
          filterBy="name,friendly_name"
          [filterPlaceHolder]="'search' | translate"
          [scrollHeight]="listboxScrollHeight"
          [emptyMessage]="'noResultsFound' | translate"
          class="w-full"
          [ariaLabel]="'organisation' | translate"
        >
          <ng-template #item let-organisation>
            {{ organisationFriendlyName(organisation) }}
          </ng-template>
        </p-listbox>
      </ng-template>
    </p-step-panel>

    <p-step-panel [value]="3">
      <ng-template #content>
        <p-listbox
          id="shadowRoleListbox"
          [options]="roles()"
          optionValue="roleId"
          dataKey="roleId"
          [ngModel]="selectedRoleId()"
          (ngModelChange)="onRoleChange($event)"
          [disabled]="loadingRoles()"
          [filter]="true"
          filterBy="roleName"
          [filterPlaceHolder]="'search' | translate"
          [scrollHeight]="listboxScrollHeight"
          [emptyMessage]="'noResultsFound' | translate"
          class="w-full"
          [ariaLabel]="'roleName' | translate"
        >
          <ng-template #item let-role>
            {{ getRoleLabel(role.roleName) }}
          </ng-template>
        </p-listbox>
      </ng-template>
    </p-step-panel>
  </p-step-panels>
</p-stepper>

@if (apiError()) {
  <p class="text-red-500 mt-3 mb-0" role="alert">{{ apiError() }}</p>
}

<div class="shadow-dialog-actions">
  <p-button
    type="button"
    [outlined]="true"
    [label]="'cancel' | translate"
    (onClick)="onCancel()"
    [disabled]="submitting()"
    data-testid="shadow-dialog-cancel"
  />
  @if (activeStep() > 1) {
    <p-button
      type="button"
      [outlined]="true"
      [label]="'back' | translate"
      (onClick)="onBack()"
      [disabled]="submitting()"
      data-testid="shadow-dialog-back"
    />
  }
  <p-button
    type="button"
    [label]="'proceed' | translate"
    (onClick)="onProceed()"
    [disabled]="
      submitting() ||
      (activeStep() === 1 && (!canProceedStep1() || loadingOrgTypes())) ||
      (activeStep() === 2 && (!canProceedStep2() || loadingOrganisations())) ||
      (activeStep() === 3 && (!canProceedStep3() || loadingRoles()))
    "
    [loading]="submitting() || loadingOrganisations() || loadingOrgTypes() || loadingRoles()"
    data-testid="shadow-dialog-proceed"
  />
</div>
